import module from 'finanzas/module.js'
import template from './template.html'

module.config(($stateProvider) => {
  $stateProvider.state('finances.divisas', {
    url: '/divisas?{periodo:date}',
    data: {
      title: 'Divisas',
    },
    resolve: {
      Catalogos: ($catalogos) => {
        return $catalogos.$fetch()
      },
      Data: (FinanzasDivisas, $stateParams) => {
        var period = $stateParams['periodo'] = $stateParams['periodo'] || new Date()
        return FinanzasDivisas.select(period, '2').then(function (data) {
          var year = period.getFullYear()
          var month = period.getMonth()
          var days = new Date(year, month + 1, 0).getDate()

          var calendar = Array.apply(null, new Array(days)).map(function (item, index) {
            return {Fecha: new Date(year, month, index + 1)}
          })

          data.forEach(function (item) {
            calendar[item['Fecha'].getDate() - 1] = item
          })
          return calendar
        })
      },
    },
    template,
    controllerAs: 'ctrl',
    controller (Data, Catalogos, $stateParams, $dialog, $state) {
      var ctrl = this

      ctrl.catalogos = Catalogos

      ctrl.options = {
        periodo: $stateParams['periodo'],
        moneda: '2',
        // diasEnPeriodo:
        ultimoRegistro: Data.reduce(function (prev, current) {
          return Math.max(prev, current['Fecha'].getDate())
        }, 1),
      }

      ctrl.options.periodo.setDate(1)

      ctrl.data = Data

      ctrl.search = function () {
        $state.go($state.current, {periodo: ctrl.options.periodo.toYMD()})
      }

      ctrl.set = function (data) {
        data = data || {
          Fecha: ctrl.options.periodo,
          Tipo_Moneda: '2',
        }
        $dialog.show('finances.divisas.agregar', {data: angular.copy(data)}).then(function () {
          $state.reload()
        })
      }

      ctrl.filters = {
        currency: $stateParams['currency'],
      }
    },
  })
})



// WEBPACK FOOTER //
// ./src/finanzas/_/divisas/finances-divisas.js